import { useMemo } from 'react';

import { DataTable, Tooltip, type TableColumn } from '@/src/ui';
import type { StudentHandscoreDTO } from '../TeacherDashboardDTOs';
import { ReportHeaderStyle, ReportCellStyle } from '@/src/utils';

interface HandscoreItemsTableProps {
    data: Array<StudentHandscoreDTO>;
}

export default function HandscoreItemsTable(props: HandscoreItemsTableProps) {
    const { data } = props;

    const columns = useMemo<TableColumn[]>(() => {
        if (!data || data.length === 0) return [];
        const cols: TableColumn[] = [
            {
                dataKey: 'studentName',
                header: 'Student',
                align: 'left',
                allowSort: true,
                emptyValue: '-',
                headerSx: ReportHeaderStyle,
                cellSx: ReportCellStyle,
            },
            {
                dataKey: 'questions',
                header: 'Questions',
                align: 'left',
                allowSort: true,
                emptyValue: '-',
                headerSx: ReportHeaderStyle,
                cellSx: ReportCellStyle,
                formatter: (row: StudentHandscoreDTO) => {
                    const nQuestions = row.questions.length;
                    let tooltipText = row.questions
                        .slice(0, 10)
                        .map((q) => q.questionTitle)
                        .join('\n');
                    if (nQuestions > 10) {
                        tooltipText += `\n...and ${nQuestions - 10} more.`;
                    }
                    return (
                        <Tooltip tooltipText={tooltipText}>
                            {row.questions.length}{' '}
                            {row.questions.length === 1 ? 'Question' : 'Questions'}
                        </Tooltip>
                    );
                },
            },
        ];
        return cols;
    }, [data]);

    return (
        <DataTable
            columns={columns}
            data={data}
            tableName="Students"
            rowsPerPageInitial={5}
            rowsPerPageList={[5]}
            alternatingRowColor
            defaultSortColumn="name"
            defaultSortDirection="asc"
        />
    );
}
